import { useEffect, useState, useCallback } from "react";
import apiClient from "../api/apiClient";
import apiPaths from "../api/endpoints";

type FeedScopeType = "school" | "user" | "grade";

interface UseDashboardFeedParams {
  feedScopeType: FeedScopeType;
  schoolHash?: string;
  studentId?: string;
  grade?: string;
  enabled?: boolean; // ✅ added
}

// export function useDashboardFeed({
//   feedScopeType,
//   schoolHash,
//   studentId,
//   grade,
//   enabled = true, // ✅ default true
// }: UseDashboardFeedParams) {
//   const [data, setData] = useState<any>(null);
//   const [loading, setLoading] = useState<boolean>(false);
//   const [error, setError] = useState<string | null>(null);

//   const fetchFeed = useCallback(async () => {
//     if (!enabled) return; // ✅ guard

//     // Optional: prevent invalid school scope calls
//     if (feedScopeType === "school" && !schoolHash) return;
//     if (feedScopeType === "grade" && (!schoolHash || !grade)) return;
//     if (feedScopeType === "user" && !studentId) return;

//     try {
//       setLoading(true);
//       setError(null);

//       const params: any = { feedScopeType };

//       if (schoolHash) params.schoolHash = schoolHash;
//       if (studentId) params.studentId = studentId;
//       if (grade) params.grade = grade;

//       const res = await apiClient.get(apiPaths.DASHBOARD_FEED, {
//         params,
//       });

//       setData(res.data);
//     } catch (err: any) {
//       console.error("Feed API error:", err);
//       setError(
//         err?.response?.data?.message ||
//         err.message ||
//         "Something went wrong"
//       );
//     } finally {
//       setLoading(false);
//     }
//   }, [feedScopeType, schoolHash, studentId, grade, enabled]);

//   useEffect(() => {
//     if (!enabled) return; // ✅ prevent first undefined render call
//     fetchFeed();
//   }, [fetchFeed, enabled]);

//   return {
//     data,
//     loading,
//     error,
//     refetch: fetchFeed,
//   };
// }
export function useDashboardFeed({
  feedScopeType,
  schoolHash,
  studentId,
  grade,
  enabled = true,
}: UseDashboardFeedParams) {

  const [data, setData] = useState<any>({
    allData: [],
    updatedData: null,
  });

  const [fromTime, setFromTime] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchFeed = useCallback(async () => {
    if (!enabled) return;

    if (feedScopeType === "school" && !schoolHash) return;
    if (feedScopeType === "grade" && (!schoolHash || !grade)) return;
    if (feedScopeType === "user" && !studentId) return;

    try {
      setLoading(true);

      const params: any = { feedScopeType };

      if (schoolHash) params.schoolHash = schoolHash;
      if (studentId) params.studentId = studentId;
      if (grade) params.grade = grade;

      const res = await apiClient.get(apiPaths.DASHBOARD_FEED, {
        params,
      });

      setData({
        allData: res.data.contents || [],
        updatedData: res.data.contents || [],
      });

      setFromTime(res.data.from);
      console.log('from time',res?.data?.from)

    } catch (err: any) {
      console.error("Feed API error:", err);
      setError(
        err?.response?.data?.message ||
        err.message ||
        "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  }, [feedScopeType, schoolHash, studentId, grade, enabled]);



  const fetchMoreFeed = useCallback(async () => {

    if (!enabled) return;

    if (data.updatedData && data.updatedData.length === 0) {
      return;
    }

    try {
      setLoading(true);

      const params: any = { feedScopeType };

      if (schoolHash) params.schoolHash = schoolHash;
      if (studentId) params.studentId = studentId;
      if (grade) params.grade = grade;
      if (fromTime) params.contentCapturedAt = fromTime;

      const res = await apiClient.get(apiPaths.DASHBOARD_FEED, {
        params,
      });

      const newContents = res.data.contents || [];

      setData((prev: any) => ({
        allData: [...prev.allData, ...newContents],
        updatedData: newContents,
      }));

      setFromTime(res.data.from);

    } catch (err) {
      console.error("Pagination error:", err);
    } finally {
      setLoading(false);
    }

  }, [feedScopeType, schoolHash, studentId, grade, fromTime, data.updatedData, enabled]);



  useEffect(() => {
    if (!enabled) return;

    setFromTime(null);
    fetchFeed();

  }, [fetchFeed, enabled]);



  return {
    data,
    loading,
    error,
    refetch: fetchFeed,
    fetchMoreFeed,
  };
}